// import axios from 'axios';
import { axiosPrivate } from "../api/axiosapi";
import { useEffect } from "react";
import useRefreshToken from "./useRefreshToken";
import useAuth from "./useAuth";

// const axiosPrivate = axios.create({
// 	// 요청 설정
// 	baseURL: 'https://develop.tiffmath.kr/api',
// 	// timeout: 10000,
// 	headers: {
// 		'Content-Type': 'application/json',
// 		// 추가적인 헤더 설정 가능
// 	}
// });

const useAxiosPrivate = () => {
    const refresh = useRefreshToken();
    const { auth } = useAuth();

    useEffect(() => {

        const requestIntercept = axiosPrivate.interceptors.request.use(
            config => {
                if (!config.headers['Authorization']) {
                    config.headers['Authorization'] = `Bearer ${auth?.accessToken}`;
                }
                return config;
            }, (error) => Promise.reject(error)
        );

        const responseIntercept = axiosPrivate.interceptors.response.use(
            response => response,
            async (error) => {
                const prevRequest = error?.config;
                if (error?.response?.status === 401 && !prevRequest?.sent) {
                    prevRequest.sent = true;
                    const newAccessToken = await refresh();
                    if(newAccessToken !== 'notoken') {
                        prevRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
                    }
                    return axiosPrivate(prevRequest);
                }
                return Promise.reject(error);
            }
        );

        return () => {
            axiosPrivate.interceptors.request.eject(requestIntercept);
            axiosPrivate.interceptors.response.eject(responseIntercept);
        }
    }, [auth, refresh])

    return axiosPrivate;
}

export default useAxiosPrivate;